import React, { useState, } from 'react';
import { toast } from 'react-toastify';
import { Button, } from 'reactstrap';

import useDocumentSubscription from './hooks/useDocumentSubscription';

export default function EditButton ({ label = '編集', type = 'update', icon = <span className="fas fa-edit" />, validateOnSubmit = _ => true, itemRef, item: itemProp, FormModal, formProps, processValues = _ => _, onFinish = _ => _, ...extraProps }) {
  const [showsModal, setShowsModal] = useState(false);
  const itemFromSubscription = useDocumentSubscription(showsModal && itemProp == null && itemRef, [showsModal]);
  const item = itemProp ?? itemFromSubscription;
  const onSubmit = async (values) => {
    if(!(await validateOnSubmit({ id: itemRef.id, ...values }))) return;
    try {
      const processedValues = await processValues(values);
      await itemRef[type](processedValues);
      toast.success('保存しました');
      await onFinish(values);
      setShowsModal(false);
    } catch(e) {
      console.error(e);
      toast.error('失敗しました');
    }
  };

  return (
    <Button color="secondary" onClick={_ => setShowsModal(true)} data-operation-type="write" {...extraProps}>
      {icon}
      {label && <span className="ml-1">{label}</span>}
      {
        (item != null || (type === 'set' && item === null)) && (
          <FormModal isOpen={showsModal} values={item} onClickClose={_ => setShowsModal(false)} onSubmit={onSubmit} {...formProps} />
        )
      }
    </Button>
  );
};
